module.exports = __webpack_public_path__ + "img/2.c1391760.png";